import XForm from 'components/XForm';
import { InputNumber, Button, notification } from 'antd';
import { useRef, useState, useEffect } from 'react';
import { getConfigApi, putConfigApi } from 'api/sysConfig';

const SystemConfig = props => {
    const xFormRef = useRef(null);
    useEffect(() => {
        getConfigApi().then(res => {
            if (res.success === true) {
                const {
                    waiting,
                    checkIn,
                    visitLimitDay,
                    visitlimitTakeCareSelf,
                    visitlimitSemiCare,
                    visitlimitFullCare,
                } = res;
                xFormRef.current.form?.setFieldsValue({
                    waiting,
                    checkIn,
                    visitLimitDay,
                    visitlimitTakeCareSelf,
                    visitlimitSemiCare,
                    visitlimitFullCare,
                });
            }
        });
    }, []);

    const onFinish = values => {
        setSubmitLoading(true);
        putConfigApi(values).then(res => {
            if (res.success === true) {
                notification.success({
                    message: '修改成功。',
                });
                setSubmitLoading(false);
            }
        });
    };

    const [submitLoading, setSubmitLoading] = useState(false);

    const formItems = [
        {
            formItemApis: {
                label: '轮侯逾期天数',
                name: 'waiting',
                rules: [{ required: true }],
            },
            item: <InputNumber min={0} precision={0} style={{ width: 200 }} />,
        },
        {
            formItemApis: {
                label: '入住逾期天数',
                name: 'checkIn',
                rules: [{ required: true }],
            },
            item: <InputNumber min={0} precision={0} style={{ width: 200 }} />,
        },
        {
            formItemApis: {
                label: '探视天数限制',
                name: 'visitLimitDay',
                rules: [{ required: true }],
            },
            item: <InputNumber min={0} precision={0} style={{ width: 200 }} />,
        },
        {
            formItemApis: {
                label: '自理区每日探视人数上限',
                name: 'visitlimitTakeCareSelf',
                rules: [{ required: true }],
            },
            item: <InputNumber min={0} precision={0} style={{ width: 200 }} />,
        },
        {
            formItemApis: {
                label: '半护理区每日探视人数上限',
                name: 'visitlimitSemiCare',
                rules: [{ required: true }],
            },
            item: <InputNumber min={0} precision={0} style={{ width: 200 }} />,
        },
        {
            formItemApis: {
                label: '全理区每日探视人数上限',
                name: 'visitlimitFullCare',
                rules: [{ required: true }],
            },
            item: <InputNumber min={0} precision={0} style={{ width: 200 }} />,
        },
        {
            item: (
                <div style={{ textAlign: 'center' }}>
                    <Button type="primary" htmlType="submit" loading={submitLoading}>
                        提交
                    </Button>
                </div>
            ),
        },
    ];
    return (
        <div className="baseInfoBox">
            <XForm
                formApis={{
                    name: 'baseInfo',
                    labelCol: { span: 5 },
                    onFinish: onFinish,
                }}
                formItems={formItems}
                ref={xFormRef}
            />
        </div>
    );
};
export default SystemConfig;
